import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [role, setRole] = useState('Admin');
  const navigate = useNavigate();

  const onContinue = () => {
    if (role === 'School Teacher') navigate('/teacher-login');
    else navigate('/home');
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden md:block md:w-7/12 bg-cover bg-right" style={{ backgroundImage: `url('/school-mis.png')`, backgroundPosition: 'right' }} />
      <div className="w-full md:w-5/12 flex items-center justify-center p-8">
        <div className="max-w-md w-full space-y-6">
          <div className="flex items-center gap-3 mb-6">
            <img src="/logo-sedim.jpg" alt="logo" className="h-12 w-12 rounded-md object-cover" />
            <div className="leading-tight">
              <div className="text-xl font-semibold text-gray-800">School Management System</div>
              <div className="text-s text-gray-500"></div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow p-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Welcome to School MIS</h2>
            <p className="text-sm text-gray-500 mb-6">Select your role to continue</p>
            <label className="block text-sm font-medium text-gray-700 mb-2">Role</label>
            <select value={role} onChange={e => setRole(e.target.value)} className="w-full border px-3 py-2 rounded mb-6">
              <option>Admin</option>
              <option>School</option>
              <option>School Teacher</option>
            </select>
            <div className="flex justify-end">
              <button onClick={onContinue} className="px-4 py-2 bg-blue-600 text-white rounded">Continue</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
